<script setup lang="ts">
useHead({
  link: [
    {
      rel: 'preload',
      as: 'image',
      href: '/images/logo/logo.svg',
    },
    {
      rel: 'preload',
      as: 'image',
      href: '/images/sports/sport-home-bg-mb-v2.webp',
    },
  ],
})

const { isLogged } = useUser()
const $isLighthouseBot = useNuxtApp().$isLighthouseBot as boolean
</script>

<template>
  <div class="home">
    <DesktopHomeHeroBanner />
    <MobileHomeRecentGame v-if="isLogged" />
    <MobilePagesSportsHotmatch :is-home="true" />
    <MobileHomeTopJackpot />
    <DesktopHomeGameCategories />
    <template v-if="!$isLighthouseBot">
      <DesktopHomePopularSection />
      <DesktopHomeGameBaiSection />
      <CommonCasinoLivestream />
      <DesktopHomeLiveCasinoSection />
      <DesktopHomePromotion
        title="Khuyến mãi"
        icon="icon-promotion"
        :space-between="12"
      />
      <MobileHomeTopWinner />
    </template>
  </div>
</template>

<style scoped lang="scss">
@import '~/assets/styles/components/mobile/home/index.scss';
</style>
